<template >
  <div>
    <div class="btn-group">
      <button type="button" class="btn btn-primary" @click="filterByRegion('Europe')">EU</button>
      <button type="button" class="btn btn-primary" @click="filterByRegion('Americas')">AM</button>
      <button type="button" class="btn btn-primary" @click="filterByRegion('Asia')">AS</button>
      <button type="button" class="btn btn-primary" @click="filterByRegion('Africa')">AF</button>
      <button type="button" class="btn btn-primary" @click="filterByRegion('Oceania')">OC</button>
      <button type="button" class="btn btn-primary" @click="filterByRegion('')">ALL</button>
    </div>
  </div>
</template>
<script>
import { useStore } from 'vuex'
export default {
  setup(){
    const store = useStore()
    const filterByRegion = async (region) => {
      await store.dispatch('filterByRegion', region)
    }
    return { filterByRegion }
  }
}
</script>
<style lang="">
  
</style>